import { styled } from '@mui/material';
import MuiBox from '@mui/material/Box';
import getBasicStyles from './getBasicStyles.js';
import getSelectedStyle from './getSelectedStyle.js';

const BaseDatePickerPopper = styled(MuiBox, {
    shouldForwardProp: prop => !['hasFooter', 'isInline'].includes(prop),
}) `
  ${({ theme, hasFooter, isInline }) => getBasicStyles(theme, hasFooter, isInline)};
  .react-datepicker-popper[data-placement^='bottom'] {
    padding: ${({ theme }) => theme.spacing(1, 0, 0)};
  }

  .react-datepicker-popper[data-placement^='top'] {
    padding: ${({ theme }) => theme.spacing(0, 0, 1)};
  }

  .react-datepicker-popper[data-placement^='left'] {
    padding: ${({ theme }) => theme.spacing(0, 1, 0, 0)};
  }

  .react-datepicker-popper[data-placement^='right'] {
    padding: ${({ theme }) => theme.spacing(0, 0, 0, 1)};
  }

  .selectedDay {
    ${({ theme }) => getSelectedStyle(theme, true)};
  }

  .withinWeekRange {
    ${({ theme }) => getSelectedStyle(theme)};
    > div > p {
      color: ${({ theme }) => theme.palette.primary.light};
    }
  }

  .leftRounded,
  .react-datepicker__day--001 {
    border-bottom-left-radius: 50% !important;
    border-top-left-radius: 50% !important;
    :after {
      display: none;
    }
  }

  .withLeftBorder {
    :before {
      border-left: 1px solid ${({ theme }) => theme.palette.primary.main};
      border-bottom-left-radius: 50%;
      border-top-left-radius: 50%;
    }
    :after {
      border-top: 0;
      border-bottom: 0;
    }
  }

  .rightRounded {
    border-bottom-right-radius: 50% !important;
    border-top-right-radius: 50% !important;
  }

  .withRightBorder:before {
    border-right: 1px solid ${({ theme }) => theme.palette.primary.main};
    border-bottom-right-radius: 50%;
    border-top-right-radius: 50%;
  }
`;

export { BaseDatePickerPopper as default };
//# sourceMappingURL=BaseDatePickerPopper.js.map
